import icon1 from './components/image/icon1.jpg'
import icon2 from './components/image/icon2.jpg'
import icon3 from './components/image/icon3.jpg'
import icon4 from './components/image/icon4.jpg'
import icon5 from './components/image/icon5.jpg'
import icon6 from './components/image/icon6.jpg'
import media1 from './components/image/media/media1.jpg'
import media6 from './components/image/media/media6.jpg'
import media4 from './components/image/media/media4.jpg'


const postDataComment = [
    {
        id_comment: 1,
        user: "9hdw ",
        avatar: media6,
        comment_time: "12h",
        comment_body: "When your pets are pawfectly ready for Christmas!",
        up_votes: 120,
        down_votes: 10,
    },
    {
        id_comment: 2,
        user: "khif",
        avatar: media1,
        comment_time: "23h",
        comment_body: "Republicans are outraged that after three years",
        up_votes: 2,
        down_votes: 13,
    },
    {
        id_comment: 3,
        user: "atti18",
        avatar: icon4,
        comment_time: "15h",
        comment_body: "exactly my thoughts. No drama. I like her",
        up_votes: 22,
        down_votes: 19,
    },
    {
        id_comment: 4,
        user: "takedahiromitsu",
        avatar: icon5,
        comment_time: "4h",
        comment_body: "Someone asked for a rumble?",
        up_votes: 38,
        down_votes: 2,
    },
    {
        id_comment: 5,
        user: "notsi",
        avatar: icon6,
        comment_time: "13h",
        comment_body: "hahahah, so lool",
        up_votes: 20,
        down_votes: 39,
    },
    {
        id_comment: 6,
        user: "lara_@d",
        avatar: icon1,
        comment_time: "3h",
        comment_body: "Don't be broke. You can get 20 year olds no problem",
        up_votes: 22,
        down_votes: 133
    },
    {
        id_comment: 7,
        user: "joo_21",
        avatar: icon2,
        comment_time: "2h",
        comment_body: "I have to admit she took it better than expected",
        up_votes: 28,
        down_votes: 4,
    },
    {
        id_comment: 8,
        user: "sam213_l",
        avatar: icon1,
        comment_time: "8h",
        comment_body: "Uncle Ruckus (no relation) would be jealous.",
        up_votes: 42,
        down_votes: 39,
    },
    {
        id_comment: 9,
        user: "yase&d2",
        avatar: icon3,
        comment_time: "2h",
        comment_body: "That is an arousing armpi",
        up_votes: 28,
        down_votes: 64,
    },
    {
        id_comment:10,
        user: "thisi",
        avatar: media4,
        comment_time: "5h",
        comment_body: "It's definitely a foot. No question.",
        up_votes: 67,
        down_votes: 31,
    }
];


export default postDataComment;